/**
 * Dispatch events for tracking Adobe Primetime with Segment.
 *
 * @param {Object} detail Event details.
 */
export default (detail) => {
  document.dispatchEvent(
    new CustomEvent('AdobePrimetime', {
      detail,
    }),
  );
};
